import { http } from '@/lib/http';
import type { CaseFilters, CaseRow, IPage } from './types';

// Cursor-paginated case list (FROZEN contract — `?limit&cursor` →
// `{ items, nextCursor }`, no `total`). The cursor is opaque: the caller echoes
// a prior page's `nextCursor` back verbatim and never constructs one. `limit`
// is left to the BFF default (50, hard max 200) unless a caller overrides it.
export async function listCases(
  filters: CaseFilters,
  cursor?: string,
): Promise<IPage<CaseRow>> {
  const search = new URLSearchParams();
  if (filters.airport) search.set('airport', filters.airport);
  // Header airport scope (NEX-310) — the NEX-308 frozen wire: a CSV of
  // concrete IATA codes; the BFF pushes it to the domain server-side.
  if (filters.airports) search.set('airports', filters.airports);
  if (filters.status) search.set('status', filters.status);
  if (filters.from) search.set('from', filters.from);
  if (filters.to) search.set('to', filters.to);
  if (filters.bucket) search.set('bucket', filters.bucket);
  if (filters.archived) search.set('archived', 'true');
  if (cursor) search.set('cursor', cursor);
  const qs = search.toString();
  return http.get(qs ? `v1/cases?${qs}` : 'v1/cases').json<IPage<CaseRow>>();
}
